'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.dayBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/dayBefore.js
// module id = 661
// module chunks = 0